/* global System */

export default {
  VerticalTabs: () =>
    System.import(/* webpackChunkName: "VerticalTabs" */ './index'),
}
